<template>
  <div class="custom-field-simple-select-container">
    <span
      v-if="isDisplayOnly"
    >
      {{ selectedOpportunityStageMaster(model)?.stageName }}
    </span>
    <BSelect
      v-else
      v-model="model"
      v-model:valid="isValid"
      :items="opportunityStageMasters"
      :required="required"
      item-text="stageName"
      item-value="id"
      fit
      filterable
    />
  </div>
</template>

<script lang="ts" setup>
import {  ref, watch, computed } from 'vue';
import { OpportunityStageMasters } from '@/api/openapi';
import { OpportunityStageMasterApiApiService } from '@/api/user/resources/opportunity_stage_master';
import { useWait } from '@/composable/vue-wait';

// openapi の OpportunityStageMasters スキーマに id が未定義だが、
// 実レスポンス（OpportunityStageMasterResource）は id を返すためここで補う。
type TOpportunityStageMaster = OpportunityStageMasters & { id?: number };

type TProps = {
  required: boolean;
  isDisplayOnly: boolean;
  waitKeySuffix?: string;
};

type TEmits = {
  'change': [number | null];
};

const props = defineProps<TProps>();
const emit = defineEmits<TEmits>();

const { doActionWithWait } = useWait();

const model = defineModel<number | null>();
const isValid = defineModel<boolean>('isValid', { default: false });

const opportunityStageMasters = ref<TOpportunityStageMaster[]>([]);

const loadOpportunityStageMasters = async () => {
  const api = new OpportunityStageMasterApiApiService();
  await doActionWithWait(`fetchOpportunityStages${props.waitKeySuffix ?? ''}`, async () => {
    const { data } = await api.getOpportunityStageMasters({});
    opportunityStageMasters.value = data.opportunityStageMasters;
  });
};


loadOpportunityStageMasters();

const selectedOpportunityStageMaster = (opportunityStageMasterId: number | null | undefined) => {
  return opportunityStageMasters.value.find((opportunityStageMaster) => opportunityStageMaster.id === opportunityStageMasterId);
};

const handleChange = () => {
  emit('change', model.value);
};

watch(model, () => {
  handleChange();
});
</script>

<style lang="scss" scoped>
.custom-field-simple-select-container {
  position: relative;

  .custom-field-icon {
    margin-right: 1px;
  }
  .custom-field-btn {
    position: absolute;
    bottom: 46px;
    right: 0;
  }
}
</style>
